import React, {useEffect, useLayoutEffect, useState} from "react";
import {atom, createCtx} from "@reatom/core";
import {reatomComponent, reatomContext} from "@reatom/npm-react";

const Context = React.createContext({});


function createStore(Component, Models, data) {
  const ctx = createCtx()
  const models = Object.keys(Models).reduce((acc, name) => {
    const initData = data[name.toLowerCase()] || {}
    acc[name] = new Models[name](ctx, initData)
    return acc;
  }, {});

  return (props) => {
    return (
      <Context.Provider value={models}>
        <reatomContext.Provider value={ctx}>
          <Component {...props}/>
        </reatomContext.Provider>
      </Context.Provider>
    )
  }
}

const StoreCtx = reatomComponent(({ctx, Component, models, ...props}) => {
  Object.keys(models).forEach(( name) => {
    models[name].onSpy(ctx)
  });
  return <Component {...models} {...props}/>
})

function withStore(Component) {
  return (props) => {
    return (
      <Context.Consumer>
        {(models) => {
          return <StoreCtx Component={Component} models={models} {...props}/>
        }}
      </Context.Consumer>
    )
  }
}

export {
  createStore,
  withStore
}